import { ChatEmptyState } from "src/base-components/Chat/ChatEmptyState";
import { ChatEmptyStatePrompt } from "src/base-components/Chat/types";
import { FeatureQueryConversationContextContextTypeEnum } from "src/clients/copilot";
import { NODE_TYPE } from "src/constants/NodeTypes";
import { ResourceType } from "src/copilot/utils";

const getSuggestions = (
  nodeType?: NODE_TYPE,
  resourceType?: ResourceType,
): ChatEmptyStatePrompt[] => {
  if (
    resourceType ===
    FeatureQueryConversationContextContextTypeEnum.FEATURE_QUERY
  ) {
    return [
      "Calculate the total transaction amount in the last 30 days by card",
      "Calculate the total transaction amount in the last 60 days by card",
      "Calculate the average transaction amount in the last 90 days by card",
    ].map((s) => ({ label: s, prompt: s }));
  }
  if (nodeType === NODE_TYPE.SQL_DATABASE_CONNECTION_NODE) {
    return [
      "Show me which tables are available",
      "Relevant tables for credit underwriting",
      "Check if applicant is blacklisted",
    ].map((s) => ({ label: s, prompt: s }));
  }
  return [
    "Calculate the applicant's age from their birth date",
    "Explain what this node does",
    "Refactor this node to simplify it's logic",
  ].map((s) => ({ label: s, prompt: s }));
};

export const EmptyState: React.FC<{
  onPromptClick: (prompt: string) => void;
  nodeType?: NODE_TYPE;
  resourceType?: ResourceType;
}> = ({ onPromptClick, nodeType, resourceType }) => {
  const prompts = getSuggestions(nodeType, resourceType);
  return <ChatEmptyState prompts={prompts} onPromptClick={onPromptClick} />;
};
